// 404 страница
import Header from '../layout/Header';
import Footer from '../layout/Footer';

export default function NotFoundPage() {
  return (
    <div className="min-h-screen bg-white font-sans flex flex-col">
      <Header onHomeClick={() => window.location.href = '/'} />

      <main className="flex-1 relative overflow-hidden">
        <img
          src="/not_found.jpg"
          alt=""
          className="absolute left-0 top-0 h-full w-auto max-w-[50%] object-cover opacity-30"
        />
        <div className="relative z-10 flex items-center justify-center h-full px-4">
          <div className="text-center max-w-md">
            <h1 className="text-[120px] font-bold text-gradient leading-none mb-4">
              404
            </h1>
            <h2 className="text-2xl md:text-3xl font-bold text-brand-dark mb-4">
              Страница не найдена
            </h2>
            <p className="text-lg text-brand-dark/70 mb-8">
              Кажется, такой страницы не существует. Возможно, она была удалена или вы перешли по неверной ссылке.
            </p>
            <a
              href="/"
              className="inline-block px-8 py-4 rounded-2xl bg-gradient-to-r from-brand-red via-brand-pink to-brand-orange text-white text-sm font-medium tracking-[-0.14px] hover:opacity-95 transition"
            >
              На главную
            </a>
          </div>
        </div>
      </main>

      <Footer
        onMyVideosClick={() => {}}
        onGenerateClick={() => window.location.href = '/'}
      />
    </div>
  );
}
